import { inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';

@Injectable({
  providedIn: 'root',
})
export class EmailService {
  private static readonly EMAIL_KEY = 'EmailAddress';
  private readonly storage: StorageService = inject(LOCAL_STORAGE);

  public get(): string {
    return this.storage.get(EmailService.EMAIL_KEY);
  }

  public set(email: string) {
    this.storage.set(EmailService.EMAIL_KEY, email);
  }

  public remove() {
    this.storage.remove(EmailService.EMAIL_KEY);
  }
}
